import { AppContext } from "01Data/AppData";
import { IFMapImage } from "01Data/DataTypes";
import { MapReader } from "97Parts/MapReader";
import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useContext, useState } from "react";

export interface IFDlgCaller {
  // ダイアログ表示状態
  bShow(): boolean;
  // ダイアログを閉じる
  close: () => void;
  // アクション
  action: (data: any) => Promise<void>;
  // 全体再描画
  redraw: () => void;
}

const FormDlg = styled("form")(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: "100%", // Fix IE 11 issue.
}));

const MessageText = styled("div")(({ theme }) => ({
  color: "#00f",
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
}));

const ButtonDlg = styled(LoadingButton)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

export const RegisterFormBuilding = ({ caller }: { caller: IFDlgCaller }) => {
  const d = useContext(AppContext).dataUser.locations;
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [message, setMesasge] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  class ImageData implements IFMapImage {
    setFileName(name: string): void {
      setFileName(name);
    }
    getFileName(): string {
      return fileName;
    }
    setFileExtension(extension: string): void {
      setFileExtension(extension);
    }
    setData(data: string): void {
      setData(data);
    }
    setError(err: any, message: string): void {
      d.SetError(err, message);
      caller.redraw();
    }
    clear() {
      setFileName("");
      setData("");
      d.SetError(null, "");
    }
  }

  const handleClose = () => {
    setName("");
    setAddress("");
    setMesasge("");
    setFileName("");
    setFileExtension("");
    setData("");
    d.errorMessage = "";
    caller.close();
  };

  const handleChangeName = (e: any) => {
    setName(e.target.value);
    d.errorMessage = "";
    setMesasge("");
  };
  const handleChangeAddress = (e: any) => {
    setAddress(e.target.value);
    d.errorMessage = "";
    setMesasge("");
  };

  const handleRegister = async () => {
    if (name === "") {
      d.errorMessage = "建物名を入力してください。";
      caller.redraw();
      return;
    }
    setMesasge("登録中・・・");
    try {
      setLoading(true);
      await caller.action({
        name: name.replaceAll(`"`, `\\"`),
        syokenId: "",
        address: address.replaceAll(`"`, `\\"`),
        image: data,
        imageExtension: fileExtension,
      });
      setMesasge("登録完了");
      setTimeout(() => handleClose(), 500);
    } catch (err) {
      setMesasge("");
      if ((err as Error).message === "すでに存在") {
        d.SetError(err, "建物はすでに登録されています。");
      } else {
        d.SetError(err, "建物登録に失敗しました。");
      }
      caller.redraw();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog sx={{ minWidth: "50%" }} key="register" open={caller.bShow()}>
      <FormDlg noValidate>
        <DialogTitle>建物登録</DialogTitle>
        <DialogContent>
          <TextField
            variant="filled"
            margin="normal"
            fullWidth
            required
            id="name"
            label="名前"
            name="name"
            onChange={handleChangeName}
            inputProps={{ maxLength: 128 }}
            value={name}
          />
          <TextField
            variant="filled"
            margin="normal"
            fullWidth
            id="address"
            label="住所"
            name="address"
            onChange={handleChangeAddress}
            inputProps={{ maxLength: 128 }}
            value={address}
          />
          <MapReader entity={new ImageData()} redraw={() => {}} />
          {message !== "" ? <MessageText>{message}</MessageText> : null}
          {d.errorMessage !== "" ? (
            <ErrorText>{d.errorMessage}</ErrorText>
          ) : null}
          <DialogActions>
            <ButtonDlg
              variant="contained"
              color="primary"
              onClick={handleRegister}
              loading={loading}
            >
              登録
            </ButtonDlg>
            <ButtonDlg
              variant="contained"
              color="primary"
              onClick={handleClose}
            >
              キャンセル
            </ButtonDlg>
          </DialogActions>
        </DialogContent>
      </FormDlg>
    </Dialog>
  );
};
